// Local Dev
const LOCAL_ENDPOINT = 'http://localhost:3000';
// Dev
const DEV_ENDPOINT = 'https://dev.purplevisitsapi.com';
// Staging
const STAGING_ENDPOINT = 'https://staging.purplevisitsapi.com';
// Prod
const PROD_ENDPOINT = 'https://prod.purplevisitsapi.com';
// Aus Prod
const AUS_PROD_ENDPOINT = 'https://ausprod.purplevisitsapi.com';

const LOCAL = 'local';
const DEV = 'dev';
const STAGING = 'staging';
const PROD = 'prod';

const UK = 'uk';
const AUS = 'aus';

let REGION = UK;

// <! --- The ENV const below is the only thing that needs changing manually in this file --- >

// const ENV = LOCAL;
const ENV = DEV;
// const ENV = STAGING;
// const ENV = PROD;

export function getRestEndpoint() {
  let restEndpoint;
  switch (ENV) {
    case LOCAL:
      restEndpoint = LOCAL_ENDPOINT;
      break;
    case DEV:
      restEndpoint = DEV_ENDPOINT;
      break;
    case STAGING:
      restEndpoint = STAGING_ENDPOINT;
      break;
    case PROD:
      switch (REGION) {
        case AUS:
          restEndpoint = AUS_PROD_ENDPOINT;
          break;
        case UK:
          restEndpoint = PROD_ENDPOINT;
          break;
        default:
          restEndpoint = PROD_ENDPOINT;
      }
      break;
    default:
      restEndpoint = PROD_ENDPOINT;
  }
  return restEndpoint;
}

export function setRegion(country) {
  switch (country) {
    case AUS:
      REGION = AUS;
      break;
    case UK:
      REGION = UK;
      break;
    default:
      REGION = UK;
  }
}
